import { Button, Switch } from 'geniebook-ui/dist';
import React, { useEffect, useState } from 'react';

export type TimedWorksheetOptionProps = {
  createWorksheet: () => void;
  onSetTimedWorksheet: (isTimed: boolean) => void;
  compact?: boolean;
  isSubscriptionDelayed?: boolean;
  textColor?: string;
  handleShowSubscriptionDelayedError: () => void;
};

const TimedWorksheetOption = ({
  createWorksheet,
  onSetTimedWorksheet,
  compact = false,
  isSubscriptionDelayed,
  textColor,
  handleShowSubscriptionDelayedError,
}: TimedWorksheetOptionProps) => {
  const [isUsingTimed, setIsUsingTimed] = useState(false);

  const onCheckTimed = () => {
    if (isSubscriptionDelayed) return;

    setIsUsingTimed(!isUsingTimed);
  };

  useEffect(() => {
    onSetTimedWorksheet(isUsingTimed);
  }, [isUsingTimed]);

  return (
    <div className={`${textColor || 'text-neutral-chalk'}`}>
      <div
        className={`flex ${compact ? 'mb-0.5' : 'mb-2'} place-content-between`}
      >
        <span className="items-center font-bold">Timed Worksheet</span>
        <div>
          <Switch
            checked={isUsingTimed}
            onClick={() => {
              onCheckTimed();
            }}
          />
        </div>
      </div>
      <div className={`${compact ? 'mb-1' : 'mb-4'} text-sm`}>
        {compact
          ? 'Approximately 30 mins - 45 mins'
          : 'Duration of worksheet will be approximately 30 mins - 45 mins'}
      </div>
      <Button
        className={'!max-w-full !font-black'}
        onClick={() => {
          if (isSubscriptionDelayed) handleShowSubscriptionDelayedError();
          else createWorksheet();
        }}
        disabled={false}
      >
        Create worksheet
      </Button>
    </div>
  );
};

export default TimedWorksheetOption;
